


























import CommonBase from "../CommonBase";
import {Component, Inject} from "vue-property-decorator";
import {NativeApi} from "@/modules/NativeBridge";
import rd from "@/modules/vRoutedefs";
import IosWebviewButNotAppWarning from "@/components/shared/IosWebviewButNotAppWarning.vue";

@Component({
    components: {
        "at-ios-webview-not-app": IosWebviewButNotAppWarning,
    }
})
export default class About extends CommonBase {
    @Inject()
    nativeApi!: NativeApi;

    get privacypolicyTo() {
        return {name: rd.about.privacypolicy.name};
    }

    get introDocTo() {
        return {path: rd.docs.intro.path};
    }

    get usertermsTo() {
      return {name: rd.about.userterms.name}
    }
}
